import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { api } from '$app/api';

const ListLicensePhotos = ({ ownerId, side }) => {
  const [photoLinks, setPhotoLinks] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadPhotoLinks = async () => {
      try {
        const { data } = await api.get('/media/signed-links', {
          params: {
            ownerId,
          },
        });
        if (!isMounted) return;
        const signedLinks = (data || [])
          .filter((mediaObj) => mediaObj.bucketPath.includes(side.toLowerCase()))
          .map((obj) => obj.signedLink);
        setPhotoLinks(signedLinks);
        setHasError(false);
      } catch (error) {
        if (!isMounted) return;
        setHasError(true);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPhotoLinks();

    return () => {
      isMounted = false;
    };
  }, [ownerId, side]);

  if (loading) return 'Fetching driving license photos..';
  if (hasError) return 'Failed to fetch driving licence photos!';

  if (photoLinks && photoLinks.length > 0) {
    return (
      <ul>
        {photoLinks.map((link, index) => (
          <li key={Math.random() * 10}>
            <a href={link} target="_blank" rel="noreferrer">{`Download Photo ${index + 1}`}</a>
            <br />
          </li>
        ))}
      </ul>
    );
  }

  return 'No Driving Lincense Photos Found';
};

ListLicensePhotos.propTypes = {
  ownerId: PropTypes.string.isRequired,
  side: PropTypes.string.isRequired,
};

export default ListLicensePhotos;
